import BaseApi from './baseApi';
import ISystemSettings from '../models/ISystemSettings';
import IAuthentication from '../models/IAuthentication';
export default class SystemSettingsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "CompanySettings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetSystemSettings() : Promise<ISystemSettings[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var systemSettings: ISystemSettings[] = [];
            systemSettings = response.data as ISystemSettings[];
            return systemSettings;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveSystemSettings(systemSettings: ISystemSettings) : Promise<string> {
        const json = this.getJsonSave(systemSettings);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateSystemSettings(systemSettings: ISystemSettings) : Promise<boolean> {
        const json = this.getJsonUpdate(systemSettings);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteSystemSettings(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "SettingsSystem",
                "Item2": "id"
            }, {
                "Item1": "SettingsSystem",
                "Item2": "keySettings"
            }, {
                "Item1": "SettingsSystem",
                "Item2": "description"
            }, {
                "Item1": "SettingsSystem",
                "Item2": "value"
            }],
            "tables": [{
                "Item1": "SettingsSystem"
            }],
            "conditions": [{
                "Item1": "SettingsSystem",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
    
    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "SettingsSystem",
            "conditions": [{
                "Item1": "SettingsSystem",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(systemSettings: ISystemSettings) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "keySettings",
                "Item2": systemSettings.keySettings
            }, {
                "Item1": "description",
                "Item2": systemSettings.description
            }, {
                "Item1": "value",
                "Item2": systemSettings.value
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "SettingsSystem"
        };
        return json;
    }

    private getJsonUpdate(systemSettings: ISystemSettings) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "keySettings",
                "Item2": systemSettings.keySettings
            }, {
                "Item1": "description",
                "Item2": systemSettings.description
            }, {
                "Item1": "value",
                "Item2": systemSettings.value
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "SettingsSystem",
            "keyvalue": systemSettings.id
        };
        return json;
    }
}
